import { register } from 'swiper/element/bundle'

export default defineNuxtPlugin({
  parallel: true,
  setup: () => {
    register()
  },
})
